module.exports = "//cdn-static.kwai.net/kos/s101/nlav11312/incentive-encourage/static/img/coin-snack.915c71e4.png";